import React, { useState } from "react";
import { Image } from "./image";

export const Gallery = (props) => {
  const [active, setActive] = useState(null);
  const items = props.data || [];

  return (
    <div id="gallery" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>From the Quarry and the Factory</h2>
          <p>
            Our own sites, our own material — photographed on the bench, in the
            slab hall and on the loading yard.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {items.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                <Image
                  title={d.title}
                  largeImage={d.largeImage}
                  smallImage={d.smallImage}
                  onOpen={() => setActive(d)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {active ? (
        <div className="lightbox" onClick={() => setActive(null)} role="dialog">
          <button type="button" className="lightbox-close" aria-label="Close">
            &times;
          </button>
          <figure onClick={(e) => e.stopPropagation()}>
            <img src={active.largeImage} alt={active.title} />
            <figcaption>{active.title}</figcaption>
          </figure>
        </div>
      ) : null}
    </div>
  );
};
